<template>
	<div class="article main-content">
		<el-row>
			<el-col class="pull-left" style="width: 100px;">
				<!-- <el-button size="small" type="primary" @click="$router.push({ path: '/article/create' })">添加文章</el-button> -->
				<el-button size="small" type="primary" @click="toAddArticle">添加文章</el-button>
			</el-col>
			<el-col class="pull-right" style="width: 100px;">
				<el-button size="small" type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
			</el-col>
			<el-col class="pull-right" style="width: 160px; margin-right: 20px;">
				<el-select size="small" v-model="params.status" placeholder="文章状态">
					<el-option label="全部状态" value></el-option>
					<el-option label="显示" :value="1"></el-option>
					<el-option label="禁用" :value="2"></el-option>
				</el-select>
			</el-col>
			<el-col class="pull-right" style="width: 160px; margin-right: 20px;">
				<el-select size="small" v-model="params.type" placeholder="文章类型">
					<!-- <el-option :value="undefined" label="全部类型"></el-option> -->
					<el-option :value="1" label="帮助文章"></el-option>
					<!-- <el-option :value="2" label="消息文章"></el-option>
					<el-option :value="3" label="活动文章"></el-option> -->
				</el-select>
			</el-col>
			<el-col class="pull-right" style="width: 160px; margin-right: 20px;">
				<el-input size="small" v-model="params.title" placeholder="请输入标题名称"></el-input>
			</el-col>
		</el-row>
		<el-table :data="listData" v-loading="loading">
			<el-table-column label="ID" prop="id" width="60"></el-table-column>
			<el-table-column label="标题" prop="title"></el-table-column>
			<el-table-column label="作者" prop="author"></el-table-column>
			<el-table-column label="浏览量" prop="review"></el-table-column>
			<el-table-column label="时间" prop="created_at"></el-table-column>
			<el-table-column label="状态">
				<template slot-scope="scope">
					<span>{{scope.row.status === 1 ? '显示' : '禁用'}}</span>
				</template>
			</el-table-column>
			<el-table-column label="操作" width="160">
				<template slot-scope="scope">
					<!-- <el-button
						size="small"
						type="primary"
						@click="$router.push({path: `/article/detail/${scope.row.id}`})"
					>查看</el-button>
					<el-button
						size="small"
						type="primary"
						@click="$router.push({path: `/article/edit/${scope.row.id}`})"
					>编辑</el-button> -->
					<el-button
						size="small"
						type="primary"
						@click="pathToDetail(scope.row.id)"
					>查看</el-button>
					<el-button
						size="small"
						type="primary"
						@click="pathToEdit(scope.row.id)"
					>编辑</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-row style="margin-top: 20px;">
			<el-col>
				<el-pagination
					background
					layout="prev, pager, next"
					:total="listMeta.total || 0"
					@current-change="handlePageChange"
					:current-page="listMeta.current_page || 1"
					:page-size="listMeta.per_page || 15"
				></el-pagination>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
	data() {
		return {
			loading: false,
			params: {
				title: '',
				status: undefined,
				page: 1,
				type: 1
			}
		}
	},
	computed: {
		...mapState({
			listData: state => state.data.articleList,
			listMeta: state => state.data.articleListMeta
		})
	},
	methods: {
		...mapActions(['getArticleList']),
		handlePageChange(page) {
			this.params.page = page
			this.getTableData()
		},
		handleSearch() {
			this.params.page = 1
			this.getTableData()
		},
		getTableData() {
			this.loading = true
			this.getArticleList(this.params).finally(() => {
				this.loading = false
			})
		},
		toAddArticle () {
			let routeArticle = this.$router.resolve({ path: '/article/create' })
			window.open(routeArticle.href, '_blank')
		},
		pathToDetail (id) {
			let routeDetail = this.$router.resolve({ path: `/article/detail/${id}` })
			window.open(routeDetail.href, '_blank')
		},
		pathToEdit (id) {
			let routeEdit = this.$router.resolve({ path: `/article/edit/${id}` })
			window.open(routeEdit.href, '_blank')
		}
	},
	created() {
		this.getTableData()
	}
}
</script>

<style>
</style>
